"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Stack = function Stack(_ref) {
  var _classNames;

  var children = _ref.children,
      classes = _ref.classes,
      dataTestId = _ref.dataTestId,
      isCentered = _ref.isCentered,
      stackId = _ref.stackId,
      verticalSpacing = _ref.verticalSpacing;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": dataTestId,
    id: stackId,
    className: (0, _classnames.default)("stack", (_classNames = {}, _defineProperty(_classNames, "stack--centered", isCentered), _defineProperty(_classNames, "stack-vertical-spacing--".concat(verticalSpacing), verticalSpacing), _classNames), classes)
  }, children);
};

Stack.propTypes = {
  /**
   Required. Stacks must contain something.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,

  /**
   Optional. Custom Stack classes.
   */
  classes: _propTypes.default.string,

  /**
   Optional, but recommended. Gives a unique identifier to the element which is useful for testing scenarios.
   */
  dataTestId: _propTypes.default.string,

  /**
   Optional. Defaults to false.
   */
  isCentered: _propTypes.default.bool,

  /**
   Optional. Custom id for top-level Stack element.
   */
  stackId: _propTypes.default.string,

  /**
   Optional. Sets space between Stack children: '0','10','20','30','40','50','60','70','80','90','100','110','120','130'
   */
  verticalSpacing: _propTypes.default.oneOf(['0', '10', '20', '30', '40', '50', '60', '70', '80', '90', '100', '110', '120', '130'])
};
Stack.defaultProps = {
  classes: null,
  dataTestId: null,
  isCentered: false,
  stackId: null,
  verticalSpacing: '40'
};
var _default = Stack;
exports.default = _default;